import { render, staticRenderFns } from "./couponsAward.vue?vue&type=template&id=df469e38&scoped=true"
import script from "./couponsAward.vue?vue&type=script&lang=js"
export * from "./couponsAward.vue?vue&type=script&lang=js"
import style0 from "./couponsAward.vue?vue&type=style&index=0&id=df469e38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df469e38",
  null
  
)

export default component.exports